module.exports = __webpack_public_path__ + "img/IMG_1962_P_Foamcore_MockedUp.37309885.jpg";